'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type PropsWithChildren, useContext, useMemo, useState } from 'react';
import { type HeaderAccountDropdownContent } from '../../graphql/get-header-profile-dropdown-content';
import { ImpersonationModal } from './impersonation-modal';
const ImpersonationModalContext = createContext<null | {
  openImpersonationModal: () => void;
}>(null);
export const ImpersonationModalProvider = t0 => {
  const $ = _c(8);
  const {
    children,
    cmsContent
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      openImpersonationModal: () => setIsOpen(true)
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const value = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== cmsContent || $[3] !== isOpen) {
    t3 = <ImpersonationModal cmsContent={cmsContent} isOpen={isOpen} onClose={t2} />;
    $[2] = cmsContent;
    $[3] = isOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <ImpersonationModalContext.Provider value={value}>{children}{t3}</ImpersonationModalContext.Provider>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export const useImpersonationModalContext = () => {
  const value = useContext(ImpersonationModalContext);
  if (!value) {
    throw new Error(`${useImpersonationModalContext.name} must be used inside of ${ImpersonationModalProvider.name}`);
  }
  return value;
};